import { useState } from 'react'
import { useLocation } from 'react-router-dom'

import { useFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'

import { LOCAL_STORAGE_KEY } from '../constants/appConstants'

export const useManagerCoachingBanner = () => {
  const { isManagerCoachingEnabled, isGoogleCatalystHomebaseBannerEnabled } = useFlags()
  const location = useLocation()

  const hasVisitedManagerCoachingMicrosite =
    localStorage.getItem(LOCAL_STORAGE_KEY.HAS_VISITED_MANAGER_COACHING_MICROSITE) === 'true'
  const hasNavigatedToProviderBooking =
    localStorage.getItem(LOCAL_STORAGE_KEY.HAS_NAVIGATED_TO_MANAGER_COACHING_PROVIDER_BOOKING) === 'true'
  const [isManagerCoachingBannerDismissed, setIsManagerCoachingBannerDismissed] = useState(
    localStorage.getItem(LOCAL_STORAGE_KEY.HAS_DISMISSED_MANAGER_COACHING_BANNER) === 'true',
  )

  const isOnHomebasePage = location.pathname === '/secure/index/search-care'
  const showManagerCoachingBanner =
    isManagerCoachingEnabled &&
    isGoogleCatalystHomebaseBannerEnabled &&
    isOnHomebasePage &&
    hasVisitedManagerCoachingMicrosite &&
    !hasNavigatedToProviderBooking &&
    !isManagerCoachingBannerDismissed

  return { showManagerCoachingBanner, setIsManagerCoachingBannerDismissed }
}
